import { createFileRoute } from '@tanstack/react-router'
import { JobActivity } from '@/features/job-detail/activity'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/activity')({
  component: JobActivity,
})
